import React, { useState } from "react";
import { BACKEND_URL } from "../lib/supabase";

export default function PlanButton(props) {
  var p = props.plan;
  var [hov, setHov] = useState(false);
  var [loading, setLoading] = useState(false);

  async function handleCheckout() {
    // If not logged in, send to auth first
    if (!props.user) {
      props.onNeedAuth && props.onNeedAuth();
      return;
    }
    setLoading(true);
    try {
      var res = await fetch(BACKEND_URL + "/api/create-checkout-session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ plan: p.name.toLowerCase(), email: props.user.email }),
      });
      var data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert("Payment error: " + (data.error || "Unknown error"));
        setLoading(false);
      }
    } catch (err) {
      alert("Could not connect to payment server. Please try again.");
      setLoading(false);
    }
  }

  return (
    <button
      onClick={handleCheckout}
      onMouseEnter={function() { setHov(true); }}
      onMouseLeave={function() { setHov(false); }}
      disabled={loading}
      style={{
        width: "100%", padding: "13px 0", borderRadius: 100,
        fontFamily: "inherit", fontWeight: 700, fontSize: 12, letterSpacing: 1.5,
        cursor: loading ? "not-allowed" : "pointer",
        border: "1.5px solid " + p.color,
        background: hov ? p.color : p.color + "18",
        color: hov ? "#fefcfa" : p.color,
        transform: hov ? "translateY(-2px)" : "translateY(0)",
        boxShadow: hov ? "0 6px 20px " + p.color + "55" : "none",
        transition: "all 0.22s ease",
        marginTop: "auto",
        opacity: loading ? 0.7 : 1,
      }}
    >
      {loading ? "Redirecting to payment..." : "Get " + p.name + " — $" + p.price + "/mo"}
    </button>
  );
}
